angular.module('app').controller('productLegalController',
  ['$scope', function (scope) {

  }]);
